import * as React from 'react';
import { IProfile } from 'src/views/Admin/Profiles/types';

export interface IUserMarkets {
  visibilityProfiles: IProfile[];
  localUserAdminProfiles: IProfile[];
  localContentAdminProfiles: IProfile[];
}

export const emptyUserMarkets: IUserMarkets = {
  visibilityProfiles: [],
  localUserAdminProfiles: [],
  localContentAdminProfiles: [],
};

export const MarketContext = React.createContext<IUserMarkets>(
  emptyUserMarkets
);



// WEBPACK FOOTER //
// ./src/services/contexts/markets/MarketContext.ts